interface PenaltyScoreProps {
  /** Additional CSS class names to apply to the component */
  className?: string;
  /** Penalty score of the home team */
  homePenaltyScore: number;
  /** Penalty score of the away team */
  awayPenaltyScore: number;
}

export default function PenaltyScore({
  className = '',
  homePenaltyScore,
  awayPenaltyScore,
}: PenaltyScoreProps) {
  const scoreClassName = 'font-robotoMedium font-medium text-[10px] leading-[14px]';

  return (
    <div className={`flex items-center gap-0.5 text-monoX dark:text-monoY ${className}`}>
      <span className={scoreClassName}>({homePenaltyScore}</span>
      <span className="font-unibet font-medium text-[14px] leading-[8px] opacity-50">-</span>
      <span className={scoreClassName}>{awayPenaltyScore})</span>
    </div>
  );
}
